import polyglotI18nProvider from 'ra-i18n-polyglot'
import englishMessages from './en'

const defaultLocale = 'en'

const i18nProvider = polyglotI18nProvider(() => englishMessages, defaultLocale)

export default i18nProvider
